import React from 'react';

const Message = ({ notification }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      padding: '1rem',
      backgroundColor: '#222',
      borderRadius: '8px',
      color: '#fff'
    }}>
      <strong style={{ fontSize: '1.2rem', marginBottom: '0.5rem' }}>
        {notification?.title}
      </strong>
      <span>{notification?.body}</span>
    </div>
  );
};

export default Message;
